var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96252 39.5748H42.3375V42.3873H2.96252V39.5748ZM38.1188 15.6686C38.4917 15.6686 38.8494 15.5204 39.1131 15.2567C39.3769 14.993 39.525 14.6353 39.525 14.2623V10.0436C39.5249 9.75459 39.4357 9.47264 39.2697 9.23612C39.1036 8.99959 38.8687 8.81998 38.5969 8.72172L23.1281 3.09672C22.8192 2.98501 22.4809 2.98501 22.1719 3.09672L6.70315 8.72172C6.43136 8.81998 6.19645 8.99959 6.03038 9.23612C5.86431 9.47264 5.77515 9.75459 5.77502 10.0436V14.2623C5.77502 14.6353 5.92318 14.993 6.18691 15.2567C6.45063 15.5204 6.80831 15.6686 7.18127 15.6686H8.58752V33.9498H5.77502V36.7623H39.525V33.9498H36.7125V15.6686H38.1188ZM8.58752 11.028L22.65 5.90922L36.7125 11.028V12.8561H8.58752V11.028ZM25.4625 33.9498H19.8375V15.6686H25.4625V33.9498ZM11.4 15.6686H17.025V33.9498H11.4V15.6686ZM33.9 33.9498H28.275V15.6686H33.9V33.9498Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.f124c3635506c8538b336bb774b00bde.svg";
export { ForwardRef as ReactComponent };